import { useEffect } from 'react';
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './Snackbar.style';
import { ButtonFlatMediumEmphasized } from '../Buttons';
import colors from '@/theme/colors';
import {
  BodyMediumEmphasized,
  BodyMediumMidEmphasis,
  BodyMediumMidEmphasisUnderline,
} from '../Typography';

export const useSnackbar = () => {
  const showToast = ({
    message,
    onClick,
    buttonLabel,
    duration = 20000,
  }: {
    message: string;
    onClick?: () => void;
    buttonLabel?: string;
    duration?: number;
  }) => {
    toast(
      t => (
        <div className={styles.container} tabIndex={0} role="alert" aria-live="assertive">
          <span className={styles.message}>{message}</span>
          {onClick && buttonLabel ? (
            <BodyMediumMidEmphasisUnderline
              color={colors.shadesJungle500}
              onClick={() => {
                onClick();
                toast.dismiss(t.id);
              }}
            >
              {buttonLabel}
            </BodyMediumMidEmphasisUnderline>
          ) : (
            <IconButton
              onClick={() => toast.dismiss(t.id)}
              aria-label="Dismiss Notification"
              data-testid="dismissNotification"
            >
              <CloseIcon className={styles.closeIcon} />
            </IconButton>
          )}
        </div>
      ),
      {
        duration,
      }
    );
  };

  return showToast;
};

export const SnackbarProvider = () => {
  const { toasts } = useToasterStore();
  const TOAST_LIMIT = 1;

  useEffect(() => {
    toasts
      .filter(t => t.visible)
      .filter((_, i) => i >= TOAST_LIMIT)
      .forEach(t => toast.dismiss(t.id));
  }, [toasts]);

  return (
    <Toaster
      position="bottom-center"
      reverseOrder={false}
      gutter={0}
      toastOptions={{
        className: styles.toastStyle,
      }}
    />
  );
};
